module.exports = __webpack_public_path__ + "static/media/Quicksand-Regular.3f178e7b.woff2";